import {
    useTheme,
    Box,
    TextField 
} from "@mui/material";

const DescriptionInput = ({ description, setDescription }) => {
    const theme = useTheme();
    return (
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
            <Box 
                className="square" 
                sx={{
                    mt: '2vw', 
                    width: '90%', height: '100%', 
                    px: 3,
                    pt: 3,
                    pb: 2.5,
                    cursor: 'pointer', boxShadow: theme.palette.squareBoxShadow,
                    border: theme.palette.tinyBorder,
                }}
            >
                <TextField 
                    fullWidth 
                    id="url_description"
                    multiline
                    maxRows={7}
                    placeholder="What's this link about?"
                    onChange={e => setDescription(e.target.value)}
                    value={description}
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                        '& .MuiInputBase-input': {
                            fontSize: "17px", 
                            "&::-webkit-scrollbar": {
                                width: "8px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                backgroundColor: theme.palette.mode === "light" ? "#c1c1c1" : "#6b6b6b",
                                borderRadius: "4px",
                                cursor: 'grab',
                            },
                            "&::-webkit-scrollbar-track": {
                                backgroundColor: theme.palette.mode === "light" ? "#F0F0F0" : theme.palette.background.paper,
                                borderRadius: "4px",
                            },
                            '&::-webkit-scrollbar-thumb:active': {
                                cursor: 'grabbing',
                            },
                        }
                    }}
                />
            </Box>
        </Box>
    );
}

export default DescriptionInput;